import { Col, Row, Form as AntdForm } from 'antd'
import { FormItem, Input, Title } from '../styles'
import { Container, Form, RadioGroup, Radio } from './styles'
import ThaiBathInput from '../ThaiBathInput'
import CompensationRequestByBankInputGroup from '../CompensationRequestByBankInputGroup'
import CompensationRequestByChequeInputGroup from '../CompensationRequestByChequeInputGroup'
import MedicalExpenseTable from '../MedicalExpenseTable'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'
import { useRecoilValue } from 'recoil'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'
import { useHealthClaimForm } from '@/contexts/healthClaimForm'

function CompensationRequestPanel() {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateOrEditMode =
    healthClaim.mode === HealthClaimModeEnum.CREATE || healthClaim.mode === HealthClaimModeEnum.EDIT
  const {
    forms: { compensationRequestForm },
    markEditedOnce,
  } = useHealthClaimForm()
  const reimbursementMethod = AntdForm.useWatch('reimbursementMethod', compensationRequestForm)
  const isRequired = { required: true, message: 'กรุณากรอกข้อมูลนี้' }

  return (
    <Container>
      <Form
        form={compensationRequestForm}
        layout="vertical"
        requiredMark={false}
        onValuesChange={markEditedOnce}
        key={`${healthClaim.mode}-${healthClaim.data?.claimFormId || 'new'}`}
      >
        <Title>ความประสงค์ของผู้เอาประกันภัย</Title>
        {/* ส่วนที่ 1 ระบุค่ารักษา และเลขที่ใบเสร็จ */}
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <FormItem
              name="treatmentAmount"
              label="จำนวนค่ารักษาพยาบาลตามใบเสร็จ *"
              rules={[isRequired]}
            >
              <ThaiBathInput disabled={!isCreateOrEditMode} />
            </FormItem>
          </Col>
          <Col className="gutter-row" span={6}>
            <FormItem
              name="approvedClaimAmount"
              label="จำนวนค่ารักษาพยาบาลที่อนุมัติ *"
              rules={[isRequired]}
            >
              <ThaiBathInput disabled />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <FormItem name="receiptNumber" label="เลขที่ใบเสร็จ *" rules={[isRequired]}>
              <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
            </FormItem>
          </Col>
        </Row>
        {/* ส่วนที่ 2 ระบุรายการค่ารักษาพยาบาล */}
        <MedicalExpenseTable />
        {/* ส่วนที่ 3 ระบุช่องทางรับค่าสินไหมทดแทน */}
        <FormItem name="reimbursementMethod" label="ช่องทางรับค่าสินไหมทดแทน">
          <RadioGroup
            value={reimbursementMethod}
            onChange={(e) => {
              compensationRequestForm.setFieldsValue({ reimbursementMethod: e.target.value })
            }}
            disabled={!isCreateOrEditMode}
          >
            <Radio value="BANK">บัญชีธนาคาร</Radio>
            <Radio value="POSTALCHECK">ไปรษณีย์</Radio>
          </RadioGroup>
        </FormItem>
        {reimbursementMethod === 'BANK' && (
          <>
            {/* ส่วนที่ 3.1 เลือกช่องทางรับค่าสินไหมทดแทน "บัญชีธนาคาร" */}
            <CompensationRequestByBankInputGroup />
          </>
        )}
        {reimbursementMethod === 'POSTALCHECK' && (
          <>
            {/* ส่วนที่ 3.2 เลือกช่องทางรับค่าสินไหมทดแทน "ไปรษณีย์" */}
            <CompensationRequestByChequeInputGroup />
          </>
        )}
      </Form>
    </Container>
  )
}

export default CompensationRequestPanel
